module.exports = __webpack_public_path__ + "img/avatar5.9419a426.png";